(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var FRAMES = 24;

  function setFrame(el, deg) {
    var f = Math.round(deg / 15) % FRAMES;
    if (f < 0) f += FRAMES;
    if (el._f === f) return;
    el._f = f;
    el.style.backgroundPosition = ((f % 6) / 5 * 100) + '% ' + (Math.floor(f / 6) / 3 * 100) + '%';
  }
  function ease(k) { return 1 - Math.pow(1 - k, 3); }
  function onVisible(el, cb) {
    if (!('IntersectionObserver' in window)) { cb(true); return; }
    new IntersectionObserver(function (es) { es.forEach(function (e) { cb(e.isIntersecting); }); }, { rootMargin: '80px' }).observe(el);
  }
  if (reduce) return;

  /* Hero stage */
  document.querySelectorAll('[data-motion-stage]').forEach(function (stage) {
    var bottles = Array.prototype.slice.call(stage.querySelectorAll('[data-spin]'));
    var panel = stage.querySelector('.mx-panel');
    var mx = 0, my = 0, tx = 0, ty = 0, visible = true, running = false;
    var sway = finePointer ? 22 : 16;
    bottles.forEach(function (b) {
      b._spr = b.querySelector('.mx-spr');
      b._ph = parseFloat(b.getAttribute('data-ph')) || 0;
      b._depth = parseFloat(b.getAttribute('data-depth')) || 0;
      b._spin = -1;
      if (finePointer) {
        b.addEventListener('mouseenter', function () { b._spin = performance.now(); });
        b.addEventListener('mouseleave', function () { b._spin = -1; });
      }
    });
    if (finePointer) {
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        tx = (e.clientX - r.left) / r.width - 0.5; ty = (e.clientY - r.top) / r.height - 0.5;
      });
      stage.addEventListener('pointerleave', function () { tx = 0; ty = 0; });
    }
    function tick(now) {
      if (!visible) { running = false; return; }
      mx += (tx - mx) * 0.08; my += (ty - my) * 0.08;
      var t = now / 1000;
      bottles.forEach(function (b) {
        var a = sway * Math.sin(t * 0.9 + b._ph) + mx * 70;
        if (b._spin > 0) a += ((now - b._spin) / 1400) * 360;
        setFrame(b._spr, a);
        b.style.transform = 'translate(' + (mx * 40 * b._depth).toFixed(1) + 'px,' + (my * 26 * b._depth).toFixed(1) + 'px)';
      });
      if (panel) panel.style.transform = 'translate(' + (-mx * 14).toFixed(1) + 'px,' + (-my * 10).toFixed(1) + 'px)';
      requestAnimationFrame(tick);
    }
    function start() { if (!running && visible) { running = true; requestAnimationFrame(tick); } }
    onVisible(stage, function (v) { visible = v; start(); });
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
  });

  /* Need cards */
  document.querySelectorAll('[data-motion-cards]').forEach(function (grid) {
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.need-card'));
    var visible = false, running = false;
    cards.forEach(function (c, i) {
      c._spr = c.querySelector('.mx-spr');
      c._ph = i * 1.3;
      c._spin = -1;
      if (!c._spr) return;
      c.addEventListener('mouseenter', function () { c._spin = performance.now(); start(); });
      if (!finePointer) {
        onVisible(c, function (v) { if (v && !c._seen) { c._seen = true; c._spin = performance.now() + i * 180; start(); } });
      }
    });
    function tick(now) {
      if (!visible) { running = false; return; }
      var t = now / 1000;
      cards.forEach(function (c) {
        if (!c._spr) return;
        var a = 10 * Math.sin(t * 1.1 + c._ph);
        if (c._spin > 0 && now >= c._spin) {
          var k = (now - c._spin) / 1100;
          if (k >= 1) c._spin = -1; else a = 360 * ease(k);
        }
        setFrame(c._spr, a);
      });
      requestAnimationFrame(tick);
    }
    function start() { if (!running && visible) { running = true; requestAnimationFrame(tick); } }
    onVisible(grid, function (v) { visible = v; start(); });
  });
})();
